import { tap } from './custom-select/helpers';
import Select from './custom-select/select';

class CustomSelect {
	/**
	 * @param {HTMLSelectElement} element
	 */
	constructor(element) {
		this.selectEl = element;
		this.createCustomSelectElements();
		this.setup();
	}

	setup() {
		this.select = new Select(this.containerEl);
		this.containerEl.addEventListener('select', (e) => {
			this.selectEl.selectedIndex = e.detail.selectedIndex;
		});
	}

	createCustomSelectElements() {
		const containerEl = document.createElement('div');
		containerEl.classList.add('custom-select');
		containerEl.append(
			tap(document.createElement('button'), (b) => {
				b.classList.add('custom-select__button');
				b.type = 'button';
				b.role = 'combobox';
				b.ariaExpanded = false;
				b.ariaHasPopup = 'listbox';
				b.tabIndex = 0;
				b.textContent = this.selectEl.firstElementChild.textContent;
			})
		);
		containerEl.append(
			tap(document.createElement('div'), (menuEl) => {
				menuEl.classList.add('custom-select__menu');
				menuEl.role = 'listbox';
				Array.from(this.selectEl.children).forEach((o) => {
					if (o.hidden) return;
					const option = document.createElement('li');
					option.classList.add('custom-select__menu-option');
					option.append(
						tap(document.createElement('button'), (ob) => {
							ob.classList.add('custom-select__menu-option-button');
							ob.type = 'button';
							ob.role = 'option';
							ob.ariaSelected = false;
							ob.textContent = o.textContent;
						})
					);
					menuEl.append(option);
				});
			})
		);
		this.containerEl = containerEl;
		this.selectEl.after(this.containerEl);
	}
}

document.querySelectorAll('.form-field__input--select').forEach((selectEl) => {
	const customSelect = new CustomSelect(selectEl);
	selectEl._customSelect = customSelect;
});

document.querySelectorAll('.gfield--type-select select').forEach((selectEl) => {
	const containerEl = selectEl.closest('.gfield--type-select');
	const labelEl = containerEl.querySelector('.gform-field-label');
	containerEl.classList.add('gfield--type-custom-select');

	if (labelEl) {
		const placeholderOption = document.createElement('option');
		placeholderOption.value = '';
		placeholderOption.textContent = labelEl.textContent;
		placeholderOption.hidden = true;
		selectEl.prepend(placeholderOption);
	}

	const customSelect = new CustomSelect(selectEl);
	selectEl._customSelect = customSelect;
});
